import React from "react";

const CourtLinkPages = () => {
  return (
    <>
      <div className="col-12 col-sm-12 col-md-9 col-lg-9">
        <div class="other-links-page-wrapper">
          <h4>List of High Courts</h4>
          <div class="row">
            <div class="col-6 col-md-6 px-5">
              <div>
                <a target="_blank" href="http://delhihighcourt.nic.in/">
                  Delhi High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://www.allahabadhighcourt.in/">
                  Allahabad High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://hc.ap.nic.in">
                  Andhra Pradesh High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="https://tshc.gov.in/">
                  Telangana High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://bombayhighcourt.nic.in/">
                  Bombay High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="https://calcuttahighcourt.gov.in/">
                  Calcutta High Court
                </a>
              </div>

              <div>
                <a target="_blank" href="http://highcourt.cg.gov.in/">
                  Chhattisgarh High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="https://ghconline.gov.in/">
                  Gauhati High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://gujarathighcourt.nic.in/">
                  Gujarat High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://hphighcourt.nic.in/">
                  Himachal Pradesh High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://jkhighcourt.nic.in/">
                  Jammu &amp; Kashmir High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="https://jharkhandhighcourt.nic.in/">
                  Jharkhand High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://karnatakajudiciary.kar.nic.in/">
                  Karnataka High Court
                </a>
              </div>
            </div>
            <div class="col-6 col-md-6 px-5">
              <div>
                <a target="_blank" href="http://highcourtofkerala.nic.in/">
                  Kerala High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://mphc.gov.in/">
                  Madhya Pradesh High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://www.hcmadras.tn.nic.in/">
                  Madras High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://hcmimphal.nic.in/">
                  Manipur High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://meghalayahighcourt.nic.in/">
                  Meghalaya High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://www.orissahighcourt.nic.in/">
                  Orissa High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://patnahighcourt.gov.in/">
                  Patna High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://highcourtchd.gov.in/">
                  Punjab &amp; Haryana High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://hcraj.nic.in/">
                  Rajasthan High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://highcourtofsikkim.nic.in/">
                  Sikkim High Court
                </a>
              </div>
              <div>
                <a target="_blank" href="http://highcourtofuttarakhand.gov.in/">
                  Uttarakhand High Court
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div class="other-links-page-wrapper">
        <h4>List of High Courts</h4>
        <div class="row">
          <div class="col-6 col-md-6">
            <div>
              <a target="_blank" href="http://delhihighcourt.nic.in/">
                Delhi High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://www.allahabadhighcourt.in/">
                Allahabad High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://hc.ap.nic.in">
                Andhra Pradesh High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="https://tshc.gov.in/">
                Telangana High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://bombayhighcourt.nic.in/">
                Bombay High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="https://calcuttahighcourt.gov.in/">
                Calcutta High Court
              </a>
            </div>

            <div>
              <a target="_blank" href="http://highcourt.cg.gov.in/">
                Chhattisgarh High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="https://ghconline.gov.in/">
                Gauhati High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://gujarathighcourt.nic.in/">
                Gujarat High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://hphighcourt.nic.in/">
                Himachal Pradesh High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://jkhighcourt.nic.in/">
                Jammu &amp; Kashmir High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="https://jharkhandhighcourt.nic.in/">
                Jharkhand High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://karnatakajudiciary.kar.nic.in/">
                Karnataka High Court
              </a>
            </div>
          </div>
          <div class="col-6 col-md-6">
            <div>
              <a target="_blank" href="http://highcourtofkerala.nic.in/">
                Kerala High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://mphc.gov.in/">
                Madhya Pradesh High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://www.hcmadras.tn.nic.in/">
                Madras High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://hcmimphal.nic.in/">
                Manipur High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://meghalayahighcourt.nic.in/">
                Meghalaya High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://www.orissahighcourt.nic.in/">
                Orissa High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://patnahighcourt.gov.in/">
                Patna High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://highcourtchd.gov.in/">
                Punjab &amp; Haryana High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://hcraj.nic.in/">
                Rajasthan High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://highcourtofsikkim.nic.in/">
                Sikkim High Court
              </a>
            </div>
            <div>
              <a target="_blank" href="http://highcourtofuttarakhand.gov.in/">
                Uttarakhand High Court
              </a>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default CourtLinkPages;
